import z from "zod";

import { dateSchema } from "./utils";

const tvSchema = z.object({
  channel_id: z.number(),
  name: z.string(),
  dark_image_url: z.string(),
  light_image_url: z.string(),
  redirect_url: z.string(),
  program: z.object({
    title: z.string(),
    description: z.string(),
    start_time: dateSchema,
    end_time: dateSchema,
  }),
});

type Tv = z.infer<typeof tvSchema>;

const streamStopSchema = z.object({
  success: z.coerce.boolean(),
});

type StreamStop = z.infer<typeof streamStopSchema>;

export { tvSchema, type Tv, streamStopSchema, type StreamStop };
